import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=6c893562"
import script from "./EventEdit.js?vue&type=script&lang=js&external"
export * from "./EventEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports